export default function(videojs) {
	const Button = videojs.getComponent(`MenuButton`)
	const MenuItem = videojs.getComponent(`MenuItem`)
	const Component = videojs.getComponent(`Component`)

	class DownloadMenuItem extends MenuItem {
		constructor(player, item, download_button) {
			super(player, {
				label: item.label,
				selectable: true,
				selected: item.selected || false,
			})
			this.item = item
			this.download_button = download_button
		}

		handleClick() {
			this.selected = false
			const video_title = this.download_button.title
			const file_name = `${ video_title.slice(0, 5) === `T.REX` ? `` : `T.REX ARMS - ` }${ video_title }`
			window.location.href = `https://stream.mux.com/${ this.download_button.mux_playback_id }/${ this.item.value }.mp4?download=${ file_name }`
		}
	}

	class DownloadButton extends Button {
		constructor(player, { mux_playback_id, title }) {
			super(player, {})
			this.controlText(`Download Video`)

			this.mux_playback_id = mux_playback_id
			this.title = title
		}

		createMenu() {
			const VideoJsMenuClass = videojs.getComponent(`Menu`)

			const menu = new VideoJsMenuClass(this.player_, { menuButton: this })

			// Add a title list item to the top
			const titleEl = videojs.dom.createEl(`li`, {
				className: `vjs-menu-title`,
				innerHTML: `Download`,
				tabIndex: -1,
			})
			const titleComponent = new Component(this.player_, { el: titleEl })

			menu.addItem(titleComponent)

			const items = [{
				label: `720p`,
				value: `high`,
			}, {
				label: `540p`,
				value: `medium`,
			}, {
				label: `360p`,
				value: `low`,
			}]

			for (const item of items) {
				menu.addItem(new DownloadMenuItem(this.player_, item, this))
			}

			return menu
		}
	}

	videojs.registerComponent(`DownloadButton`, DownloadButton)

	function downloadButton(options) {
		const menu_position = this.player_.controlBar.children().length - 1

		this.ready(() => {
			const download_icon = videojs.dom.createEl(
				`div`,
				{
					className: `download_icon`,
					innerHTML: `<svg viewBox="0, 140, 250, 250"><path d="M229.2188 261 L125.1562 365.0625 L21.0938 261 L73.125 261 L73.125 156.9375 L177.1875 156.9375 L177.1875 261 L229.2188 261 Z" stroke="none"></path></svg>`,
				}
			)

			this.getChild(`controlBar`)
				.addChild(`DownloadButton`, options, menu_position)
				.addChild(new Component(this.player_, { el: download_icon }))
		})
	}

	videojs.registerPlugin(`downloadButton`, downloadButton)
}
